import React from "react";

export function withProps<Props, Keys extends keyof Props>(
  Component: (props: Props) => JSX.Element | null,
  props: Pick<Props, Keys>
): (props: Omit<Props, Keys>) => JSX.Element | null {
  // @ts-ignore
  return (otherProps) => <Component {...otherProps} {...props} />;
}
